<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <DateRangePicker id="account-daterangepicker" @update:date="handleRangeDate" />
      </div>
    </template>

    <template #layoutContent>
      <div class="card shadow-sm mb-5 p-5 px-10">
        <h3 class="mt-1">{{currentSociety?.name}}</h3>
        <div class="row mt-5">
          <OfficeCountCard class="mb-4"  v-for="office in offices" :with-count="false" :key="office.id" :office="office" v-model="activeOfficeId"/>
        </div>
      </div>

      <div class="card shadow-sm mb-5 py-5">
        <div class="card-body">
          <div class="h-100 d-flex align-items-stretch flex-column">
            <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x fs-4 fw-bold mb-n2">
              <li v-if="can(abilities.VIEW_ACCOUNT)" class="nav-item">
                  <a class="nav-link text-active-primary pb-4 active" data-bs-toggle="tab"
                  href="#kt_accounts">
                    <div class="d-flex justify-content-center align-items-center">
                      <Img filename="account.png" class="img" style="width: 25px; height: 25px;"/>
                      <h2 class="ms-3 mt-2">{{$t('financial.accounts.account_title')}}</h2>
                    </div>
                  </a>
              </li>
              <li v-if="can(abilities.VIEW_BOX)" class="nav-item">
                  <a class="nav-link text-active-primary pb-4" data-bs-toggle="tab"
                  href="#kt_boxes">
                    <div class="d-flex justify-content-center align-items-center">
                      <Img filename="box.png" class="img" style="width: 25px; height: 25px;"/>
                      <h2 class="ms-3 mt-2">{{$t('financial.accounts.box_title')}}</h2>
                    </div>
                  </a>
              </li>
            </ul>
            

            <div class="tab-content mt-5 mb-10">
              <div class="tab-pane fade show active" id="kt_accounts" role="tab-panel">
                  <AccountComponent v-if="can(abilities.VIEW_ACCOUNT)" :office="activeOfficeId" :filterStatAccount="query" :society="currentSociety?.id"/>
              </div>
              <div class="tab-pane fade" id="kt_boxes" role="tab-panel">
                  <BoxComponent v-if="can(abilities.VIEW_BOX)" :officeId="activeOfficeId" :filterStatBox="query" :societyId="currentSociety?.id"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </SubLayout>
</template>
<script setup> 
import {onMounted, ref, computed, watch, nextTick} from "vue";
import {useStore} from "vuex";
import {$formatLocalAmount} from "@/mixins/Helpers";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useLocales} from "@/composables/locales";
import DateRangePicker from "@/components/DateRangePicker.vue";
import Button from "@/components/Button";
import i18n from "@/plugins/i18n";
import {useRouter, useRoute} from 'vue-router';
import Input from "@/components/Input.vue";
import {formattedLocalAmount} from "@/mixins/Helpers";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import AccountComponent from "./AccountView"
import BoxComponent from "./BoxView"
import {useHasAbility} from "@/composables/hasAbility";
import abilities from "@/composables/abilities";
import OfficeCountCard from "@/components/OfficeCountCard.vue";
import Img from "@/components/Img.vue";

const store = useStore()
const {locale} = useLocales()
const router = useRouter()
const route = useRoute()
const { can } = useHasAbility()

const activeOfficeId = ref('')

const title = ref("menu.financial.accounts")
const breadcrumbs = ref([
    {
      name: 'Dohler West Africa',
      path: '/admin/crm/finances/accounts'
    }
])

const status = ref([
  {
    id: 1,
    name: "Validé"
  }
])

const query = ref({
  start_date: '',
  end_date: ''
})
const isLoading = ref(true)
const getFistOffice = ref({})

const offices = computed(() => (store.getters['offices/getSocietyOffices']))
const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])
const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])

watch(() => offices.value, (value) => {
  if(value){
    activeOfficeId.value = value[0]?.id
  }
})

watch(() => activeOfficeId.value, (value) => {
  if (value) {
    const office = offices.value.find(o => o.id === value);
    if (office) {
      breadcrumbs.value[0].name = office.name;
    }
  }
});


watch(() => currentSociety.value, (value) => {
  loadData()
})

watch(() => getFistOffice.value, (value) => {
  if(value){
    breadcrumbs.value[0].name = getFistOffice.value?.name
    activeOfficeId.value = getFistOffice.value?.id
  }
})

function selectedOffice(id, name) {
  activeOfficeId.value = id
  breadcrumbs.value[0].name = name
}

function handleRangeDate (range) {
  query.value.start_date = range.start_date
  query.value.end_date = range.end_date
}

function loadData() {
  if(currentSociety.value){
    store.dispatch('offices/loadSocietyOffices', currentSociety.value?.id) 
  }
}

onMounted(() => {
  loadData()
  store.dispatch('offices/loadOfficesBySocieties')
})
</script>

<style scoped>
  .grey-background {
    background-color: #f0f0f0;
  }
  .stat_class {
    background-color: var(--bs-light-primary);
    border-radius: 8px;
    padding: 5px;
    width: auto;
  }
</style>
